import { Helmet } from "react-helmet-async";

export const SEOHead = ({
  title = "OnPoint Authority Systems",
  description = "OnPoint Authority Systems engineers founder-independent businesses through enforceable governance, licensing, and institutional operating systems.",
  keywords = "authority systems, institutional infrastructure, business scalability, founder independence, acquisition readiness, governance, licensing",
  url = "https://onpointauthority.com",
  type = "website",
}) => {
  const fullTitle = title === "OnPoint Authority Systems" 
    ? "OnPoint Authority Systems | Institutional Authority Infrastructure"
    : `${title} | OnPoint Authority Systems`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="OnPoint Authority Systems, Inc." />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="OnPoint Authority Systems" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};
